import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../features/authentication/store/authStore';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route component that redirects unauthenticated users to login
 * Used to wrap routes that require authentication
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, hasHydrated } = useAuthStore();

  // Show loading while auth is being initialized OR while waiting for hydration
  if (isLoading || !hasHydrated()) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to login if not authenticated (only after hydration is complete)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
